import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/index.vue';
import Store from '../views/store.vue';
import Apply from '../views/apply.vue';
import Joininfo from '../views/joinInfo.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/Index',
        name: 'Index',
        meta: { backPath: 'https://h5.pzhszgh.cn/welfare' },
        component: Index
    },
    {
        path: '/Store',
        name: 'Store',
        component: Store,
        meta: { backPath: 'https://h5.pzhszgh.cn/welfare', globalData: null }
    },
    {
        path: '/Apply',
        name: 'Apply',
        component: Apply
    },
    {
        path: '/Joininfo',
        name: 'Joininfo',
        component: Joininfo
    },
    {
        path: '/billing-center',
        name: 'billing-center',
        component: () => import('../views/billing-center.vue')
    },
    {
        path: '/flq',
        name: 'flq',
        component: () => import('../views/flq.vue')
    },
    {
        path: '/welfare-voucher-detail',
        name: 'welfareVoucherDetail',
        component: () => import('../views/welfare-voucher-detail.vue')
    },
    {
        path: '/ListManagement',
        name: 'ListManagement',
        component: () => import('../views/List-Management.vue')
    },
    {
        path: '/hhk',
        name: 'hhk',
        meta: { rePath: '/index' },
        component: () => import('../views/hhk.vue')
    },
    {
        path: '/add-or-edit-hhk',
        name: 'addOrEditHhk',
        component: () => import('../views/add-or-edit-hhk.vue')
    },
    {
        path: '/md',
        name: 'md',
        meta: { rePath: '/index' },
        component: () => import('../views/md.vue')
    },
    {
        path: '/add-or-edit-md',
        name: 'addOrEditMd',
        component: () => import('../views/add-or-edit-md.vue')
    },
    {
        path: '/map',
        name: 'map',
        component: () => import('../views/map.vue')
    },
    {
        path: '/storeAdmin',
        name: 'storeAdmin',
        component: () => import('../views/store-admin.vue')
    },
    {
        path: '/storeAdmin-add',
        name: 'storeAdmin-add',
        component: () => import('../views/store-admin-add.vue')
    },
    {
        path: '/storeAdmin-detail',
        name: 'storeAdmin-detail',
        component: () => import('../views/store-admin-detail.vue')
    },
    {
        path: '/store-creater-info',
        name: 'storeCreaterFnfo',
        component: () => import('../views/store-creater-info.vue')
    },
    {
        path: '/welfare-related',
        name: 'welfare-related',
        component: () => import('../views/welfare-related.vue')
    },
    {
        path: '/write-off',
        name: 'write-off',
        component: () => import('../views/write-off.vue')
    },
    {
        path: '/scan-code',
        name: 'scan-code',
        component: () => import('../views/scan-code.vue')
    }
];

const router = new VueRouter({
    mode: 'hash',
    routes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

export default router;
